<template>
  <div class="page-content--body mounting-check">
    <div class="page-content--body-right">

      <v-card outlined>
        <v-card-title class="card-title no-border mb-0">
          Информация о чеке
          <div class="sub-title">Подзаголовок</div>
        </v-card-title>

        <div class="mounting-check--header">
          <v-btn
            type="submit"
            color="primary"
            class="btn-blue button-qr"
          >
            Сканировать QR код с чека
            <v-icon class="ml-2">mdi-barcode-scan</v-icon>
          </v-btn>
          <div class="card--notify-block notify-grey">Отсканируйте QR-код с чека, чтобы данные чека подставились автоматически</div>
        </div>

        <div class="auth-form mounting-check--subheader">
          <div class="d-flex flex-wrap justify-space-between w-100">
            <div class="add-files auth-form--wrap-col w50">
              <div class="input-label">Фото чека</div>
              <div class="">
                <div class="add-files--photos">
                  <div class="add-files--photo">
                    <i class="add-files--image-delete">
                      <svg width="26" height="26" viewBox="0 0 26 26" fill="none"
                           xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13Z"
                          fill="#D60000"/>
                        <path
                          d="M10.6818 12.966L7.47728 9.7797C6.84091 9.01124 6.84091 8.24286 7.47728 7.47456C8.25 6.84181 9.02272 6.84181 9.79544 7.47456L13 10.7288L16.2046 7.54225C16.9773 6.9095 17.75 6.9095 18.5227 7.54225C19.1591 8.31071 19.1591 9.07909 18.5227 9.84739L15.3182 12.966L18.5227 16.1525C19.1591 16.9209 19.1591 17.6893 18.5227 18.4576C17.75 19.0904 16.9773 19.0904 16.2046 18.4576L13 15.3389L9.79544 18.5254C9.02272 19.1582 8.25 19.1582 7.47728 18.5254C6.84091 17.7571 6.84091 16.9887 7.47728 16.2203L10.6818 12.966Z"
                          fill="white"/>
                      </svg>
                    </i>
                    <div class="auth-form--wrap add-photo">
                      <v-file-input
                        multiple
                        class="mt-0 pt-0"
                        accept="image/png, image/jpeg, image/bmp"
                        prepend-icon="mdi-camera-plus-outline"
                        :hide-input="true"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <v-card-title class="card-title no-border mb-0">
          Данные чека
          <div class="sub-title">Подзаголовок</div>
        </v-card-title>
        <template>
          <v-card-text>
            <v-form
              autocomplete="off"
              lazy-validation
              ref="form"
              class="auth-form"
            >
              <div class="auth-form--wrap d-flex flex-wrap">
                <div class="auth-form--wrap-col w30">
                  <div class="input-label">
                    Дата продажи
                  </div>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="computedDateFormatted"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                      />
                    </template>
                    <v-date-picker
                      v-model="dateInstallation"
                      :active-picker.sync="activePicker"
                      :max="new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)"
                      locale="ru-ru"
                      min="1950-01-01"
                      @change="SaveDate"
                      first-day-of-week="1"
                    />
                  </v-menu>
                </div>
                <div class="auth-form--wrap-col w30">
                  <div class="input-label">Время чека</div>
                  <v-text-field
                    type="text"
                    outlined
                    dense
                    required
                  />
                </div>
                <div class="auth-form--wrap-col w30">
                  <div class="input-label">Общая сумма чека</div>
                  <v-text-field
                    type="text"
                    outlined
                    dense
                    required
                  />
                </div>
                <div class="auth-form--wrap-col w30">
                  <div class="input-label">ФН номер чека</div>
                  <v-text-field
                    type="text"
                    outlined
                    dense
                    required
                  />
                </div>
                <div class="auth-form--wrap-col w30">
                  <div class="input-label">ФД номер чека</div>
                  <v-text-field
                    type="text"
                    outlined
                    dense
                    required
                  />
                </div>
                <div class="auth-form--wrap-col w30">
                  <div class="input-label">ФП номер чека</div>
                  <v-text-field
                    type="text"
                    outlined
                    dense
                    required
                  />
                </div>
              </div>

              <div class="d-flex justify-end">
                <v-btn
                  type="submit"
                  color="primary"
                  class="btn-blue button-qr"
                >
                  Проверить чек
                  <v-icon class="ml-2">mdi-playlist-check</v-icon>
                </v-btn>
              </div>

            </v-form>
          </v-card-text>
        </template>

        <template>
          <v-card-title class="card-title no-border mb-0">
            Информация об оборудовании
            <div class="sub-title">Подзаголовок</div>
          </v-card-title>

          <v-card-text>
            <v-form
              autocomplete="off"
              lazy-validation
              ref="form"
              class="auth-form"
            >
              <div class="auth-form--wrap d-flex flex-wrap justify-space-between">
                <div class="auth-form--wrap-col w30">
                  <div class="input-label">Город установки</div>
                  <v-autocomplete
                    v-model="city_id"
                    :items="cities"
                    :search-input.sync="searchCity"
                    :loading="loading"
                    :clearable="true"
                    :open-on-clear="true"
                    hide-no-data
                    class="plcolor custom-autocomplete"
                    item-text="title"
                    item-value="region_id"
                    dense
                    solo
                  />
                </div>
                <div class="auth-form--wrap-col w60">
                  <div class="input-label">Адрес установки</div>
                  <v-select
                    no-data-text="Загрузка..."
                    outlined
                    dense
                    required
                    item-text="title"
                    item-value="id"
                  />
                </div>
              </div>
              <div class="auth-form--wrap d-flex flex-wrap justify-space-between">
                <div class="auth-form--wrap-col w30">
                  <div class="input-label">Артикул изделия</div>
                  <v-text-field
                    type="text"
                    outlined
                    dense
                    required
                  />
                </div>
                <div class="auth-form--wrap-col w60">
                  <div class="input-label">Наименование изделия</div>
                  <v-text-field
                    type="text"
                    outlined
                    dense
                    required
                  />
                </div>
              </div>
            </v-form>
          </v-card-text>
        </template>

        <v-card-text>
          <div class="d-flex flex-wrap justify-space-between">
            <v-btn
              type="submit"
              color="primary"
              class="btn-blue buttons-wrap--button01"
            >
              Добавить еще одно изделие
              <v-icon class="ml-2">mdi-plus</v-icon>
            </v-btn>
            <div class="w-100">
              <div class="input-label">Комментарий</div>
              <v-textarea
                filled
                outlined
                dense
              />
            </div>
            <div class="buttons-wrap">
              <v-btn
                type="submit"
                color="yellow"
                class="btn-blue buttons-wrap--button"
              >
                Сохранить как черновик
                <v-icon class="ml-2">mdi-content-save</v-icon>
              </v-btn>
              <v-btn
                type="submit"
                color="green"
                class="btn-blue buttons-wrap--button"
              >
                Отправить на проверку
                <v-icon class="ml-2">mdi-send</v-icon>
              </v-btn>
            </div>
        </div>


        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page1',
  data() {
    return {
      activePicker: null,
      menu: false,
      dateInstallation: null,
      city_id: null,
      cities: [],
      searchCity: '',
    };
  },
  computed: {
    computedDateFormatted() {
      return this.FormatDate(this.dateInstallation);
    },
    loading() {
      return this.$store.state.loading;
    },
  },
  watch: {
    /** Вотчер для даты */
    menu(val) {
      // eslint-disable-next-line no-return-assign
      val && setTimeout(() => (this.activePicker = 'YEAR'));
    },
    /** Вотчер для автокомплита городов */
    searchCity(val) {
      if (val) {
        this.$store.getters.axl
          .post('location/api/cities/list', { term: val })
          .then((result) => {
            this.cities = result.data.cities;
          });
      }
    },
    loading() {
      return this.$store.state.loading;
    },
  },
  methods: {
    /** Записать дату */
    SaveDate(date) {
      this.$refs.menu.save(date);
    },
    /** Форматировать дату */
    FormatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
  },
};
</script>

<style lang="scss" scoped src="./style.scss"/>
